// components/PagesComponents/Users/EditUserForm.js
import React, { useState } from 'react';
import { TextField, Button, Alert, Box } from '@mui/material';
import { updateUserData } from '../../../../services/Users';

const EditUserForm = ({ user, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: user.id,
    name: user.name,
    username: user.user_name,
    type: user.type,
    password: '',
  });

  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    try {
      await updateUserData(formData);
      setMessage({ type: 'success', text: '✅ تم تحديث المستخدم بنجاح' });
      if (onSuccess) onSuccess();
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField label="الاسم" name="name" value={formData.name} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="اسم المستخدم" name="username" value={formData.username} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="الدور" name="type" value={formData.type} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="كلمة المرور الجديدة" name="password" type="password" value={formData.password} onChange={handleChange} fullWidth margin="normal" />

      <Button type="submit" variant="contained" color="primary" fullWidth>
        حفظ التعديلات
      </Button>

      {message && (
        <Alert severity={message.type} sx={{ mt: 2 }}>{message.text}</Alert>
      )}
    </Box>
  );
};

export default EditUserForm;
